import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = 'deliveries';

class DeliveryService {
  getDashboardData = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/dashboard`);
      if (response.status !== 200) {
        throw new Error();
      }
      const { data } = response.data;

      return { data };
    } catch (err) {
      throw handleError(err, "Error occurred while fetching dashboard's info.");
    }
  };

  createDelivery = async formData => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, formData);
      if (response.status !== 201) {
        throw new Error();
      }
      const { data } = response.data;

      return { data };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating delivery.');
    }
  };

  fetchDeliveries = async page => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}?page=${page}`);
      if (response.status !== 200) {
        throw new Error();
      }
      response.data.page = page;
      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching orders.');
    }
  };

  fetchDelivery = async id => {
    try {
      const response = await axiosApiClient.get(`/${BASE_URL}/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching order.');
    }
  };
}
const deliveryService = new DeliveryService();

export default deliveryService;
